import { Box, CircularProgress, Typography } from '@mui/material';
import { Styled } from './uploader.styled';
import { UploaderField } from './uploader-field';

type UploaderFiles = FileList | File[];

type UploaderComponentProps = {
    label: string;
    onProcessFiles: (files: UploaderFiles) => void;
};

const UploaderComponent = ({
    label,
    onProcessFiles,
}: UploaderComponentProps) => {
    return (
        <Styled.UploaderContainer>
            <UploaderField onChangeFiles={onProcessFiles}>
                <UnuploadedFile label={label} />
            </UploaderField>
        </Styled.UploaderContainer>
    );
};

export default UploaderComponent;

const UnuploadedFile = ({
    isLoading,
    label,
}: {
    isLoading?: boolean;
    label: string;
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                direction: 'rtl',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: { xs: 1, sm: 1.25 },
                px: { xs: 0.25, sm: 0.5 },
                pointerEvents: 'none',
            }}>
            <Box
                sx={{
                    width: { xs: 38, sm: 42 },
                    height: { xs: 38, sm: 42 },
                    flexShrink: 0,
                    borderRadius: 2.25,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'primary.main',
                    backgroundColor: 'action.hover',
                }}>
                {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                ) : (
                    <Box
                        component="i"
                        className="fa-light fa-cloud-arrow-up"
                        sx={{ fontSize: { xs: 19, sm: 21 }, lineHeight: 1 }}
                    />
                )}
            </Box>

            <Box sx={{ minWidth: 0, flex: 1, textAlign: 'right' }}>
                <Typography
                    sx={{
                        color: 'text.primary',
                        fontWeight: 600,
                        fontSize: { xs: 12.75, sm: 13.5 },
                        lineHeight: 1.8,
                    }}>
                    {label}
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        color: 'text.secondary',
                        fontSize: { xs: 10.5, sm: 11.5 },
                        lineHeight: 1.65,
                    }}>
                    برای انتخاب فایل کلیک کنید یا فایل را اینجا رها کنید
                </Typography>
            </Box>
        </Box>
    );
};
